export default "__VITE_ASSET__CwnHfWy6__"